import React, {
    PropTypes,
} from 'react';
import {CustomSelect} from '../../components';
import {Col, Glyphicon} from 'react-bootstrap';

const MenuHeader = ({locations, saleTime, onChangeLocation}) => {
    const defaultLocationId = saleTime.orderLocation;
    const locationsSelect = <CustomSelect
        pic="map-marker"
        onChange={onChangeLocation}
        valueKey="locationName"
        choices={saleTime.locations}
        idKey="locationId"
        current={defaultLocationId}
        emptyValue="Школа"
        className="mt5"
    />;
    const location = <div className="mt15 text-center">
        <Glyphicon glyph="map-marker"/>&nbsp;{locations[defaultLocationId].locationName}
    </div>;
    return (
        <div>
            <Col sm={6}>
                <h4 className="mb0 mt5">{saleTime.saleTimeName}</h4>
                <div>{locations[defaultLocationId].timeBegin.slice(0, -3)}-{locations[defaultLocationId].timeEnd.slice(0, -3)}</div>
            </Col>
            <Col sm={6}>
                {Object.keys(locations).length > 1 ? locationsSelect : location}
            </Col>
        </div>
    );
};

MenuHeader.propTypes = {
    saleTime: PropTypes.object.isRequired,
    locations: PropTypes.object.isRequired,
    onChangeLocation: PropTypes.func.isRequired,
};

export default MenuHeader;



/** WEBPACK FOOTER **
 ** ./src/modules/food/MenuHeader.js
 **/